import {
  Avatar,
  Box,
  Button,
  Card,
  CardMedia,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import Loader from "../../common/Loader";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import { Image } from "@mui/icons-material";
import { BIBlue } from "../../assets/helpers";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_TICKETS, UNSHARE_TICKET_WITH_USER1 } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PictureViewer from "../common/PictureViewer";
import ShareTicketModal from "./ShareTicketModal";
import PlaceholderImg from "../../assets/images/avtar_placeholder.jpeg";
import { English } from "../../constant/EnglishFallback";
import { useDispatch } from "react-redux";
import { createChatGroupAndNavigate } from "../../common/Helper";

const ViewTicketModal = ({
  openModal,
  closeModal,
  editTicketData,
  setSelectedTicketData,
  setShowAddTicket,
  setTicketFlag,
  ticketFlag,
  allState,
  fetchUserTicketData,
  fromFlag,
  setFromFlag
}) => {
  const [loadingViewModel, setLoadingViewModel] = useState(false);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [ticketData, setTicketData] = useState([]);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [selectedOwnerUserId, setSelectedOwnerUserId] = useState(null);
  const [pictureImageType, setPictureImageType] = useState(false);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    TEXT_ID = English?.Tickets?.TEXT_ID,
    TEXT_ISSUED_BY = English?.Tickets?.TEXT_ISSUED_BY,
    TEXT_EXPIRING = English?.Tickets?.TEXT_EXPIRING,
    TEXT_ISSUED_ON = English?.Tickets?.TEXT_ISSUED_ON,
    TEXT_MESSAGE = English?.Tickets?.TEXT_MESSAGE,
    TEXT_NO_BACK_IMAGE = English?.Tickets?.TEXT_NO_BACK_IMAGE,
    TEXT_NOT_YET_SHARED = English?.Tickets?.TEXT_NOT_YET_SHARED,
    TEXT_SHARE = English?.Tickets?.TEXT_SHARE,
    TEXT_OWNED_BY = English?.Tickets?.TEXT_OWNED_BY,
    TEXT_SHARED_WITH = English?.Tickets?.TEXT_SHARED_WITH,
    TEXT_UNSHARE = English?.Tickets?.TEXT_UNSHARE,
    TEXT_VIEW_TICKET = English?.Tickets?.TEXT_VIEW_TICKET,
    TEXT_TICKET_TYPE_FILTER_PLACEHOLDER = English?.Tickets?.TEXT_TICKET_TYPE_FILTER_PLACEHOLDER
  } = multiLanguageData?.Tickets || {};

  const fetchUserTicket = useCallback(async () => {
    setLoadingViewModel(true);
    try {
      const getObj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [
          {
            createdBy:
              ticketFlag == "shareTab" || ticketFlag == "view"
                ? editTicketData?.createdBy
                : loginData?.userInformation?.UserId,
            id: editTicketData?.id
          }
        ]
      };
      let getUserTickets = await Postrequestcall(FETCH_TICKETS, getObj, loginData?.accessToken);
      setTicketData(getUserTickets?.data?.data?.[0]);
    } catch (error) {
      console.log("fetchUserTicket-> Error While Fetching Tickets: ", error);
    } finally {
      setLoadingViewModel(false);
    }
  }, [openModal]);

  useEffect(() => {
    if (ticketFlag == "edit") {
      setTicketData(editTicketData);
    } else {
      fetchUserTicket();
    }
  }, []);

  const openMenu = (event, item) => {
    event.stopPropagation();
    event.preventDefault();
    setMoreMenuAnchorEl(event.currentTarget);
    setSelectedTicket(item);
    setSelectedOwnerUserId(null);
  };

  const openOwnerMenu = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setMoreMenuAnchorEl(event.currentTarget);
    setSelectedTicket(null);
    setSelectedOwnerUserId(ownerUserId);
  };

  const handleMoreMenuClose = (event) => {
    event.stopPropagation();
    setMoreMenuAnchorEl(null);
  };

  const handleUnShareTicket = async (event) => {
    try {
      const deleteObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        DeleteList: [
          {
            TicketId: selectedTicket?.ticketId,
            UserId: selectedTicket?.sharedWithUserId,
            SharedWithUserEmail: selectedTicket?.sharedWithEmail
          }
        ]
      };
      const res = await Postrequestcall(
        UNSHARE_TICKET_WITH_USER1,
        deleteObj,
        loginData?.accessToken
      );
      if (res?.status === 201) {
        fetchUserTicket();
        setFromFlag("viewModalSave");
        handleMoreMenuClose(event);
      }
    } catch (error) {
      console.log("handleUnShareTicket-> Error While Un Sharing Ticket: ", error);
    }
  };

  const handleEditClick = (item) => {
    setTicketFlag("edit");
    setSelectedTicketData(item);
    closeModal();
    setShowAddTicket(true);
  };

  const handlecloseModal = () => {
    setSelectedTicketData(null);
    closeModal();
    setTicketFlag("");
    if (fromFlag == "viewModalSave") {
      fetchUserTicketData();
      setFromFlag("");
    }
  };

  const handleCloseShareModal = () => {
    setShowShareModal(false);
  };

  const handleShowShareModal = () => {
    setShowShareModal(true);
  };

  const isOwnerSummaryView = ticketFlag === "shareTab" || ticketFlag === "view";
  const ownerUserId = ticketData?.userId || ticketData?.createdBy || editTicketData?.userId;
  const ownerUserName =
    ticketData?.ticketOwner || ticketData?.createdByUser || editTicketData?.ticketOwner || "";
  const ownerUserEmail = ticketData?.ticketOwnerEmail || ticketData?.createdByEmail || "";
  const ownerUserTrade = ticketData?.ticketOwnerTrade || ticketData?.createdByUserTrade || "";
  const ownerUserPicture =
    ticketData?.ticketOwnerPicture || ticketData?.createdByUserPictureUrl || PlaceholderImg;

  const navigateTochat = async (e, userId) => {
    e.preventDefault();
    createChatGroupAndNavigate(userId, loginData, dispatch, navigate);
  };

  return (
    <Modal open={openModal}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_VIEW_TICKET}</Typography>
          <Stack flexDirection={"row"}>
            {ticketFlag !== "shareTab" && ticketFlag !== "view" && (
              <IconButton color="primary" onClick={() => handleEditClick(ticketData)}>
                <EditIcon />
              </IconButton>
            )}
            <IconButton onClick={handlecloseModal}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        {loadingViewModel ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "450px"
            }}>
            <Loader />
          </Box>
        ) : (
          <Box maxHeight={"550px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
            <Stack direction={"column"} spacing={1.5}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 6 }}>
                  <CardMedia
                    component="img"
                    sx={{ height: "150px", borderRadius: "5px" }}
                    image={ticketData?.frontPictureUrl}
                    alt="Ticket Front Picture"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPictureImageType("front");
                      setPictureViewerOpen(true);
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 6 }}>
                  {ticketData?.backPictureUrl != "" ? (
                    <CardMedia
                      component="img"
                      sx={{ height: "150px", cursor: "pointer", borderRadius: "5px" }}
                      image={ticketData?.backPictureUrl}
                      alt="Ticket Back Picture"
                      onClick={() => {
                        setPictureImageType("back");
                        setPictureViewerOpen(true);
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "5px",
                        width: "100%",
                        height: "150px",
                        backgroundColor: "lightgray",
                        cursor: "pointer"
                      }}>
                      <Image fontSize="large" color="disabled" />
                      <Typography pl={1} color="textSecondary" variant="h6">
                        {TEXT_NO_BACK_IMAGE}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Divider />
              <Stack>
                <Typography variant="body2" color="textSecondary">
                  {" "}
                  {TEXT_TICKET_TYPE_FILTER_PLACEHOLDER}{" "}
                </Typography>
                <Typography variant="body1"> {ticketData?.ticketType} </Typography>
              </Stack>
              <Stack>
                <Typography variant="body2" color="textSecondary">
                  {" "}
                  {TEXT_ID}{" "}
                </Typography>
                <Typography variant="body1">
                  {" "}
                  {ticketData?.ticketId == "null" ? "" : ticketData?.ticketId}{" "}
                </Typography>
              </Stack>
              <Stack>
                <Typography variant="body2" color="textSecondary">
                  {" "}
                  {TEXT_ISSUED_BY}{" "}
                </Typography>
                <Typography variant="body1"> {ticketData?.issuedBy} </Typography>
              </Stack>
              <Stack direction={"row"} width={"100%"} spacing={1}>
                <Stack width={"50%"}>
                  <Typography variant="body2" color="textSecondary">
                    {" "}
                    {TEXT_ISSUED_ON}{" "}
                  </Typography>
                  <Typography variant="body1">
                    {" "}
                    {dayjs(ticketData?.issuedOn).format("MMMM DD, YYYY")}{" "}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography variant="body2" color="textSecondary">
                    {" "}
                    {TEXT_EXPIRING}{" "}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={"bold"}
                    color={
                      dayjs(ticketData?.expiry).isBefore(dayjs(), "day")
                        ? "secondary"
                        : "textPrimary"
                    }>
                    {" "}
                    {ticketData?.expiry
                      ? dayjs(ticketData?.expiry).format("MMMM DD, YYYY")
                      : "N/A"}{" "}
                  </Typography>
                </Stack>
              </Stack>
              <Divider />

              {isOwnerSummaryView ? (
                <Stack>
                  <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography variant="body2" color="textSecondary">
                      {TEXT_OWNED_BY}
                    </Typography>
                    <IconButton size="small" onClick={openOwnerMenu}>
                      <MoreVertIcon />
                    </IconButton>
                  </Stack>
                  <Card className="pagelist-content" sx={{ mt: 1 }}>
                    <ListItem sx={{ m: 0 }} disablePadding>
                      <ListItemButton sx={{ display: "flex", flexDirection: "row" }}>
                        <ListItemAvatar>
                          <Avatar alt="contact-PictureUrl" src={ownerUserPicture} />
                        </ListItemAvatar>

                        <ListItemText
                          primary={
                            <Typography variant="body1" maxWidth={"200px"} noWrap>
                              {ownerUserName || "-"}
                            </Typography>
                          }
                          secondary={
                            <Typography variant="body2" maxWidth={"200px"} noWrap>
                              {ownerUserTrade || ownerUserEmail || "-"}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                </Stack>
              ) : ticketData?.sharedTicketsList?.length !== 0 ? (
                <Stack>
                  <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography variant="body2" color="textSecondary">
                      {TEXT_SHARED_WITH}
                    </Typography>{" "}
                    {allState?.value === 0 && (
                      <Button variant="text" onClick={handleShowShareModal}>
                        {TEXT_SHARE}
                      </Button>
                    )}
                  </Stack>
                  <List disablePadding>
                    <Stack gap={1}>
                      {ticketData?.sharedTicketsList?.map((item, index) => {
                        return (
                          <Card key={index.toString()} className="pagelist-content">
                            <ListItem
                              sx={{ m: 0 }}
                              key={index.toString()}
                              secondaryAction={
                                <IconButton
                                  size="small"
                                  onClick={(event) => {
                                    openMenu(event, item);
                                  }}>
                                  <MoreVertIcon />
                                </IconButton>
                              }
                              disablePadding>
                              <ListItemButton
                                sx={{ display: "flex", flexDirection: "row" }}
                                onClick={() => {
                                  navigate(`/${item?.sharedWithUserId}`);
                                }}>
                                <ListItemAvatar>
                                  <Avatar
                                    alt="contact-PictureUrl"
                                    src={
                                      item?.sharedWithUserPictureUrl != ""
                                        ? item?.sharedWithUserPictureUrl
                                        : PlaceholderImg
                                    }
                                  />
                                </ListItemAvatar>

                                <ListItemText
                                  primary={
                                    <Typography variant="body1" maxWidth={"200px"} noWrap>
                                      {item?.sharedWithUser}
                                    </Typography>
                                  }
                                  secondary={
                                    <Typography variant="body2" maxWidth={"200px"} noWrap>
                                      {item?.sharedWithUserTrade}
                                    </Typography>
                                  }
                                />
                              </ListItemButton>
                            </ListItem>
                          </Card>
                        );
                      })}
                    </Stack>
                  </List>
                </Stack>
              ) : ticketFlag === "view" ? (
                <></>
              ) : (
                <Stack direction={"row"} alignItems={"center"} justifyContent={"center"}>
                  <Typography variant="body2" color="textSecondary">
                    {TEXT_NOT_YET_SHARED}
                  </Typography>{" "}
                  <Button variant="text" onClick={handleShowShareModal}>
                    {TEXT_SHARE}
                  </Button>
                </Stack>
              )}
            </Stack>
          </Box>
        )}

        {showShareModal && (
          <ShareTicketModal
            isOpen={showShareModal}
            close={handleCloseShareModal}
            tickets={[ticketData]}
            fetchUserTicket={fetchUserTicket}
            setFromFlag={setFromFlag}
          />
        )}

        {pictureViewerOpen && (
          <PictureViewer
            isOpen={pictureViewerOpen}
            onClose={() => setPictureViewerOpen(false)}
            src={
              pictureImageType === "front"
                ? ticketData?.frontPictureUrl
                : ticketData?.backPictureUrl
            }
          />
        )}

        <Menu
          style={{ boxShadow: "none" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={handleMoreMenuClose}>
          {selectedOwnerUserId ? (
            <MenuItem
              style={{ color: BIBlue }}
              onClick={(event) => {
                event.stopPropagation();
                navigateTochat(event, Number(selectedOwnerUserId));
                handleMoreMenuClose(event);
              }}>
              {TEXT_MESSAGE}
            </MenuItem>
          ) : (
            <MenuItem
              style={{ color: BIBlue }}
              onClick={(event) => {
                event.stopPropagation();
                navigateTochat(event, Number(selectedTicket?.sharedWithUserId));
                handleMoreMenuClose(event);
              }}>
              {TEXT_MESSAGE}
            </MenuItem>
          )}
          {selectedTicket && ticketFlag !== "shareTab" && (
            <MenuItem
              style={{ color: BIBlue }}
              onClick={(event) => {
                event.stopPropagation();
                handleUnShareTicket(event);
                handleMoreMenuClose(event);
              }}>
              {TEXT_UNSHARE}
            </MenuItem>
          )}
        </Menu>
      </Box>
    </Modal>
  );
};

export default ViewTicketModal;
